export default "__VITE_ASSET__Du_fzJP3__"